export const CHAT_STORAGE_KEY = 'chats'
export const EDITOR_STORAGE_KEY = 'editor'
export const NKR_STORAGE_KEY = 'nkr_chats'

export const SELECTED_MODULES_KEY = 'selected-os-module'

export const IDENTITY_PROVIDER_KEY = 'selectedIdentityProvider'

export const THEME_KEY = 'theme'

export const PENDING_CHAT_MESSAGE_KEY = 'lda:pendingChatMessage'

export const CHAT_DRAFTS_KEY = 'lda:chatDrafts'

export const EXPLICIT_PROVIDER_FLAG_KEY = 'loginMethodExplicitlySelected'
